<template>
  <o-sales-view
    nav-bar-title="VAB Assistance"
    title="VAB Assistance (Yearly)"
    image="images/vab-header.jpg"
    :points="3"
    price="123,00"
    message="Deze kost wordt jaarlijks via je Olympus-budget verrekend."
    next-link="/sales/assistance/vab/ticket/confirmation"
  >
    <o-section>
      <o-text-input value="1-XXX-XXX" icon="car" :readonly="true" />
    </o-section>
    <o-section>
      <o-text-input
        value="04-10-2018 → 04-10-2019"
        icon="date"
        :readonly="true"
      />
    </o-section>
    <o-section>
      <o-text-input value="Vervangwagen" icon="check" :readonly="true" />
    </o-section>
  </o-sales-view>
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
export default {
  name: 'Bluebike',
  components: {
    OSalesView
  }
}
</script>
